import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_DISCOUNT_FILTER,
  REQUEST_CREATE_MASTER_DISCOUNT_FILTER,
  SET_MASTER_DISCOUNT_FILTER,
  SUCCESS_CREATE_MASTER_DISCOUNT_FILTER,
  ERROR_GET_MASTER_DISCOUNT_FILTER,
  ERROR_CREATE_MASTER_DISCOUNT_FILTER,
  SET_MESSAGE_MASTER_DISCOUNT_FILTER,
  SUCCESS_DELETE_MASTER_DISCOUNT_FILTER,
  SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER,
  REQUEST_DELETE_MASTER_DISCOUNT_FILTER,
  REQUEST_UPDATE_MASTER_DISCOUNT_FILTER,
  ERROR_DELETE_MASTER_DISCOUNT_FILTER,
  ERROR_UPDATE_MASTER_DISCOUNT_FILTER,
  REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES,
  SET_MASTER_DISCOUNT_FILTER_CATEGORIES,
  ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES,
} from "./discountfilterActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterDiscountfilter: any[];
  masterDiscountfilterCat: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterDiscountfilter: [],
  masterDiscountfilterCat: [],
};

const discountfilter = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_DISCOUNT_FILTER:
    case REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES:
    case REQUEST_CREATE_MASTER_DISCOUNT_FILTER:
    case REQUEST_DELETE_MASTER_DISCOUNT_FILTER:
    case REQUEST_UPDATE_MASTER_DISCOUNT_FILTER:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_DISCOUNT_FILTER:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_DISCOUNT_FILTER:
      return {
        ...state,
        busy: false,
        message: "",
        masterDiscountfilter: action.payload,
      };

    case SET_MASTER_DISCOUNT_FILTER_CATEGORIES:
      return {
        ...state,
        busy: false,
        message: "",
        masterDiscountfilterCat: action.payload,
      };

    case SUCCESS_CREATE_MASTER_DISCOUNT_FILTER:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterDiscountfilter: [...state.masterDiscountfilter, action.payload],
      };
    case SUCCESS_DELETE_MASTER_DISCOUNT_FILTER:
      return {
        ...state,
        busy: false,
        message: "",
        masterDiscountfilter: state.masterDiscountfilter.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER:
      return {
        ...state,
        busy: false,
        message: "",
        masterDiscountfilter: state.masterDiscountfilter.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_DISCOUNT_FILTER:
    case ERROR_CREATE_MASTER_DISCOUNT_FILTER:
    case ERROR_UPDATE_MASTER_DISCOUNT_FILTER:
    case ERROR_DELETE_MASTER_DISCOUNT_FILTER:
    case ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default discountfilter;

export function useDiscountFilterMaster() {
  return useSelector((state: Record<string, any>) => state.discountfilter);
}
